<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <md-card>
      <md-card-content>
        <md-layout md-gutter>
          <md-layout md-flex="10">
            <md-button
              @click="previousFFView"
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
            >&laquo; Back</md-button>
          </md-layout>
          <!-- <md-layout md-flex="30"></md-layout>
          <md-layout md-flex="40">
            <h2 style="text-align:center">Transport Quotation</h2>
          </md-layout>-->
        </md-layout>

        <div v-if="(checkModule.indexOf('TPT')>=0)">
          <!-- /.box-header  -->
          <div class="box-body">
            <hr class="hr-s">
            <div class="box-header">
              <h5 class="box-title">
                <u>Existing TPT Quotations</u>
              </h5>
              <md-button
                @click="openTPT"
                v-if="hideButtn==false"
                class="md-raised md-primary md-button-color md-theme-default back heght-1px pull-right"
              >New TPT Quotation</md-button>
            </div>
            <table id="tpt" class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Sr no</th>
                  <th>TPT Quotation</th>

                  <th>Approval Status</th>

                  <th>Action</th>
                  <th>Print</th>

                  <!-- <th>Client Name</th> -->
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item1,index) in tptTableArry" :key="index">
                  <td>{{index+1}}</td>

                  <td
                    :style="index==0?'color:green':'color:red'"
                    class="showMoreData"
                    @click="editTPT(item1.tptQId)"
                  >
                    <b>Quotation No. :</b>
                    {{item1.tptQSeries}}
                    <br>
                    <b>Validity Date :</b>
                    {{item1.validityDate | moment}}
                    <br>
                    <span class="error">{{item1.expireStatus==1?" (Expired)":""}}</span>
                  </td>

                  <td>
                    <b>Manager Approval :</b>
                    {{item1.tptStatus=='0'?'Pending':item1.tptStatus=='1'?'Approved':'Rejected'}}
                    <br>
                    <b>Client Approval :</b>
                    {{item1.tptClientStatus=='0'?'Pending':item1.tptClientStatus=='1'?'Approved':'Rejected'}}
                  </td>

                  <!-- <td>{{item1.clientName}}</td> -->
                  <!-- <td>
                    <md-button
                      class="md-icon-button md-raised md-dense"
                      @click="editTPT(item1.tptQId)"
                    >
                      <md-icon>edit</md-icon>
                    </md-button>
                  </td>-->
                  <td
                    v-if="index=='0' && item1.tptClientStatus!='2'  && item1.tptClientStatus!='1'"
                  >
                    <b v-if="item1.tptStatus!='1'   && item1.sendHODApprove=='1' ">Sent For Approval
                      <br>
                    </b>
                    <b
                      v-else-if="item1.tptStatus=='1' && item1.sentToEnquiry=='0'"
                      class="showMoreData"
                      @click="openPop(item1)"
                    >Send To Enquiry Team
                      <br>
                    </b>
                    <b
                      v-else-if="item1.tptStatus=='1'  && item1.sentToEnquiry=='1'  "
                    >Already Sent to Enquiry Team
                      <br>
                    </b>
                    <b v-else>N/A
                      <br>
                    </b>
                  </td>
                  <td v-else>
                    <b>
                      {{item1.tptClientStatus=='2' && index==0?"Client Rejected":item1.tptClientStatus=='1' && index==0?"Client Approved":"N/A"}}
                      <br>
                    </b>
                  </td>
                  <td>
                    <md-button
                      v-if="item1.tptQuotationPdf!='' && item1.tptQuotationPdf!=null"
                      class="md-icon-button md-raised md-dense"
                      @click="Print(item1.tptQuotationPdf)"
                    >
                      <md-icon>print</md-icon>
                    </md-button>
                    <b v-else>Pdf Not Generated</b>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- /.box-body -->
          </div>
        </div>

        <!-- <div v-else>
          <hr class="hr-border">
          <h5 style="text-align:center;font-size:20px;color:red">Transportation Not Required..!</h5>
        </div>-->
        <hr class="hr-border">
      </md-card-content>
    </md-card>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="sendMail"
      ref="popMail"
    ></md-dialog-confirm>
    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="popMailAfter"></md-dialog-confirm>
  </div>
</template>




<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import { ModelListSelect } from "vue-search-select";

import "vue-loading-overlay/dist/vue-loading.css";

import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";

export default {
  beforeMount() {
    if (globalPermissionStatus("Enquiry & Pricing")) {
      this.$store.dispatch("setCurrentRoute", "/ffExportCon/viewConsoBooking");
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },

  data() {
    return {
      docURL: URL_BASE_DOC,
      isLoading: "",
      openTPTDiv: false,
      openFFDiv: false,
      openCCDiv: false,
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok"
      },
      tptModal: {
        tptQId: "",
        mainEnquiryId: "",
        enquiryClientId: "",
        driverExp: "",
        travelDur: "",
        distance: "",
        toll: "",
        mileage: "",
        dieselRate: "",
        margin: "",
        baseCost: "",
        quotRate: "",
        tptStatus: "",
        tptClientStatus: ""
      },
      ffModal: {
        mainEnquiryId: "",
        ffQId: "",
        enquiryClientId: "",
        ffType: "",
        buyingRate: "",
        ffSellingRate: "",
        shippingId: "",
        enquiryClientId: "",
        ffStatus: "",
        ffClientStatus: ""
      },
      ccModal: {
        mainEnquiryId: "",
        enquiryClientId: "",
        ccQId: "",
        ccType: "",
        ccSellingRate: "",
        ccStatus: "",
        ccClientStatus: ""
      },
      ffTypeList: [
        {
          ffTypeVal: "OceanF",
          ffTypeText: "Ocean Freight"
        },
        {
          ffTypeVal: "THC",
          ffTypeText: "THC"
        },
        {
          ffTypeVal: "RailF",
          ffTypeText: "Rail Freight"
        },
        {
          ffTypeVal: "LHC",
          ffTypeText: "Local Handling Charges"
        }
      ],
      ccList: [
        {
          ccTypeVal: "CC_Charges",
          ccTypeText: "Custom Clearance Charges"
        },
        {
          ccTypeVal: "LH_Charges",
          ccTypeText: "Local Handling Charges"
        }
      ],
      statusList: [
        {
          statusV: "1",
          statusT: "Approve"
        },
        {
          statusV: "2",
          statusT: "Reject"
        }
      ],
      newData: {
        tptQId: "",
        mainEnquiryId: "",
        tptQSeries: "",
        tptQuotationPdf: ""
      },
      hideButtn: false,
      checkModule: [],
      enquiryArry: [],
      tptTableArry: [],
      ffTableArry: [],
      ccTableArry: [],
      shippingList: []
    };
  },

  mounted() {
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date)
    }
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    // Loading
     CustomLoader,
  },

  computed: {},

  methods: {
    Print(item) {
      window.open(`${this.docURL}/TPT_QUOTATION_PDF/` + item);
    },
    openPop(item) {
      Object.keys(this.newData).map(x => {
        this.newData[x] = item[x] || "";
      });

      this.alert.content = "Send Mail To Enquiry Team..?";

      this.$refs["popMail"].open();
    },
    sendMail(type) {
      this.newData["jobType"] = "TPT";
      if (type != "cancel") {
        this.isLoading = true;
        if (this.validate != false) {
          // $("#addButtonLoaderS").css("display", "none");
          // $("#loaderS").css("display", "block");

          let options = {
            method: "POST",
            url: `${URL_BASE}/Enquiry/sendForClientTPT_VP.php`,
            data: JSON.stringify(this.newData),
            crossDomain: true,

            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId")
            }
          };

          axios(options)
            .then(result => {
              const { statusText, status, data } = result;
              // $("#loaderS").css("display", "none");
              // $("#addButtonLoaderS").css("display", "block");

              this.alert.content = "Mail Sent";
              this.$refs["popMailAfter"].open();
              this.isLoading = false;
              this.getData();
              // this.$router.push({
              //   path: "/mainEnquiry/viewMainEnqQuotationTPT"
              // });
            })
            .catch(error => {});
        }
      }
    },
    openTPT() {
      this.$sessionsStorage.set("editTPTQId", "");
      this.$router.push({
        path: "/mainEnquiry/mainEnqQuotation"
      });
    },
    openFF() {
      this.openFFDiv = true;
    },
    openCC() {
      this.openCCDiv = true;
    },

    previousFFView() {
      this.$router.push({
        path: "/viewMainEnquiryDetails/viewMainEnquiryDetails"
      });
    },

    JqueryFun() {
      return $(function() {
        $("#tpt").DataTable();
        $("#ff").DataTable();
        $("#cc").DataTable();
      });
    },

    editTPT(item) {
      this.$sessionsStorage.set("editTPTQId", item);
      this.$router.push({
        path: "/mainEnquiry/mainEnqQuotation"
      });
    },
    editFF(item) {
      Object.keys(this.ffModal).map(x => {
        this.ffModal[x] = item[x];
      });
      this.openFFDiv = true;
    },
    editCC(item) {
      Object.keys(this.ccModal).map(x => {
        this.ccModal[x] = item[x];
      });
      this.openCCDiv = true;
    },

    getData() {
      this.isLoading = true;
      let payload = {
        assignmentNo: "assignmentNo",

        mainEnquiryId:
          this.$sessionsStorage.get("editMainEnqId") != "" ||
          this.$sessionsStorage.get("editMainEnqId") != undefined
            ? this.$sessionsStorage.get("editMainEnqId")
            : ""
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/getDataMainQuot.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            console.log(data);
            if (data.enquiryData.length > 0) {
              this.enquiryArry = data.enquiryData;
              this.ffModal.enquiryClientId = data.enquiryData[0].clientId;
              this.ffModal.enquiryClientId = data.enquiryData[0].clientId;
              this.ccModal.enquiryClientId = data.enquiryData[0].clientId;
              this.checkModule = data.enquiryData[0].jobType.split(",");
              console.log(this.checkModule, "0i098");
            } else {
              this.enquiryArry = [];
            }
            if (data.tptData.length > 0) {
              this.tptTableArry = data.tptData;

              let arryStatus = this.tptTableArry.filter(x => {
                return x.tptClientStatus == "1";
              });

              if (arryStatus.length > 0) {
                this.hideButtn = true;
              }

              // let arryExpire = this.tptTableArry.filter(x => {
              //   return x.expireStatus == "0" || x.tptClientStatus == "2";
              // });

              // if (arryExpire.length > 0) {
              //   console, log("oooo");
              //   this.hideButtn = false;
              // }
            } else {
              this.tptTableArry = [];
            }
            console.log(data);
            if (data.slineDetails.length > 0) {
              this.shippingList = data.slineDetails;
            }
            this.isLoading = false;
            this.JqueryFun();
          }
        })
        .catch(error => {});
    }
  }
};
</script>
<style>
</style>




// WEBPACK FOOTER //
// viewMainEnqQuotationTPT.vue?5ced0360